import React, { useCallback } from "react";
import styled from "styled-components";
import { MountTransition } from "../../components/MountTransition";
import { IDropdownPagePosition } from "./useDropdownPosition";
import { ZIndex } from "../../constants";

type TRenderFunc = (content: React.ReactNode) => React.ReactNode;

export const PortalWrapper = styled.div`
    position: absolute;
    z-index: ${ZIndex.SELECT_PORTAL};
    pointer-events: auto;
`;

export const useRenderDropdownInPortal = (dropdownPosition: IDropdownPagePosition, inPortal: boolean): TRenderFunc => {
    return useCallback(
        content => {
            if (!inPortal) {
                return content;
            }
            return (
                <MountTransition open renderDelay={0}>
                    <PortalWrapper
                        style={{ top: dropdownPosition.y, left: dropdownPosition.x, width: dropdownPosition.width }}
                    >
                        {content}
                    </PortalWrapper>
                </MountTransition>
            );
        },
        [dropdownPosition, inPortal]
    );
};
